import React from 'react';

const PantallaSector = ({sectorFicha, preguntasFicha, selSector, setSelSector}) => {

    const handleOnChange = (item, checked) => {
        //console.log(position, item, checked);
        //console.log(item);
        //console.log(checked);

        if(checked){
            //console.log('verdadero');
            const nuevo = {id: item.id_agrupacion, valor: checked, f_valor: (checked === true) ? 1 : 0}
            setSelSector([...selSector, nuevo]);
        }else{
            //console.log('falso');
            const seleccion2 = selSector.filter(x => (x.id !== item.id_agrupacion && x.valor === true));
            //console.log(seleccion2);
            setSelSector(seleccion2);
        }
    };
      
      
    //console.log(seleccion);
    return (
        <fieldset>
            <div className='form-group'>
                <h5>2.4- {preguntasFicha[4].desc_fip_preguntaT1}</h5>
                <h6 className='ml-2 text-muted'>{preguntasFicha[4].desc_fip_preguntaT2}</h6>
                <h6 className='ml-2 text-muted'>{preguntasFicha[4].desc_fip_preguntaT3}</h6>
                <fieldset>
                    {sectorFicha.map((item, index) => {
                        return (
                            <div className='form-check form-switch' key={item.id_agrupacion} >
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    id={item.id_agrupacion}
                                    //onClick={() => handleOnChange(item.id_agrupacion)}
                                    //checked={checkedState[index]}
                                    onChange={(e) => handleOnChange(item, e.target.checked)}
                                    //defaultValue={defaultValue}
                                />
                                <label className='form-check-label' htmlFor={item.id_agrupacion}>{item.desc_agrupacion}</label>
                            </div>
                        )
                    })}
                </fieldset>
                {/*<textarea name='resp1' className='form-control' rows='1' defaultValue={resp1} onChange={setForm}></textarea>*/}
            </div>
        </fieldset>

    )
}

export default PantallaSector;
